export const STREET_NUMBER = 'street_number';
export const STREET = 'route';
export const COUNTRY = 'country';
export const POSTCODE = 'postal_code';
export const CITY = 'locality';
export const STATE = 'administrative_area_level_1';

export type IPlace = {
  address_components: { types: string[]; long_name: string; short_name: string }[];
};
